var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "groupDrawer" },
    [
      _c("div", { staticClass: "form" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "page_wrap",
          },
          [
            _c(
              "el-form",
              {
                ref: "form",
                attrs: {
                  model: _vm.form,
                  "label-width": "120px",
                  "label-position": "left",
                  rules: _vm.rules,
                },
              },
              [
                _c("div", { staticClass: "header_tips" }, [_vm._v("基本信息")]),
                _c(
                  "div",
                  { staticClass: "m-t-20" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "商品名称", prop: "contentName" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "690px" },
                          attrs: {
                            maxlength: "45",
                            type: "text",
                            "show-word-limit": "",
                          },
                          on: { input: _vm.handleInputChange },
                          model: {
                            value: _vm.form.contentName,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "contentName",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.contentName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "商品简介", prop: "columnContent" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "690px" },
                          attrs: {
                            maxlength: "200",
                            type: "textarea",
                            "show-word-limit": "",
                            rows: 4,
                          },
                          model: {
                            value: _vm.form.columnContent,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "columnContent",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.columnContent",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "交付主体", prop: "deliverySubject" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            attrs: { disabled: "" },
                            on: {
                              change: function ($event) {
                                _vm.form.assistantList = []
                              },
                            },
                            model: {
                              value: _vm.form.deliverySubject,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "deliverySubject", $$v)
                              },
                              expression: "form.deliverySubject",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v("伏羲云交付"),
                            ]),
                            _c("el-radio", { attrs: { label: 2 } }, [
                              _vm._v("非伏羲云交付"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.form.deliverySubject === 1
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "助教", prop: "assistantList" } },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "btn_primary",
                                attrs: { size: "small" },
                                on: { click: _vm.handleClickAssistantList },
                              },
                              [_vm._v("新增人员")]
                            ),
                            _vm.form.assistantList.length > 0
                              ? _c("assistantChange", {
                                  ref: "assistantChange",
                                  staticClass: "m-t-20",
                                  attrs: {
                                    data: _vm.form.assistantList,
                                    listyle: {
                                      width: "142px",
                                      marginRight: "20px",
                                    },
                                    width: "540px",
                                    del: "",
                                  },
                                  on: {
                                    onDel: _vm.handleClickAssistantDel,
                                    autoAllocation: _vm.autoAllocation,
                                    unAutoAllocation: _vm.unAutoAllocation,
                                    onDelBatch:
                                      _vm.handleClickAssistantDelBatch,
                                    onAdd: _vm.handleAssistantAdd,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      { attrs: { label: "选择IP", prop: "lecturerIdList" } },
                      [
                        _c("m-select", {
                          staticClass: "m-300",
                          staticStyle: { width: "205px" },
                          attrs: {
                            disabled: "",
                            filterable: "",
                            placeholder: "请选择老师",
                            multiple: "",
                            "dict-list": _vm.teacherOption,
                            param: {
                              value: "lecturerId",
                              label: "lecturerName",
                            },
                          },
                          model: {
                            value: _vm.form.lecturerIdList,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "lecturerIdList", $$v)
                            },
                            expression: "form.lecturerIdList",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "选择类别", prop: "curriculumType" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { placeholder: "请选择类型" },
                            model: {
                              value: _vm.form.curriculumType,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "curriculumType", $$v)
                              },
                              expression: "form.curriculumType",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { value: 3, label: "公开课" },
                            }),
                            _c("el-option", {
                              attrs: { value: 4, label: "一对一" },
                            }),
                            _c("el-option", {
                              attrs: { value: 5, label: "落地班" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "人气值", prop: "goodsPopularity" } },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "200px" },
                          attrs: { "controls-position": "right" },
                          model: {
                            value: _vm.form.goodsPopularity,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "goodsPopularity", _vm._n($$v))
                            },
                            expression: "form.goodsPopularity",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "商品主图", prop: "coverUrlList" } },
                      [
                        _c("ImageUpload", {
                          attrs: { limit: 8 },
                          on: { change: _vm.getCoverUrlList },
                          model: {
                            value: _vm.form.coverUrlList,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "coverUrlList", $$v)
                            },
                            expression: "form.coverUrlList",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "横版缩略图", prop: "coverUrl" } },
                      [
                        _c("div", [
                          !_vm.form.coverUrl
                            ? _c(
                                "div",
                                {
                                  staticClass: "image_poster",
                                  staticStyle: {
                                    width: "200px",
                                    height: "150px",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.getImgUrl("coverUrl")
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "el-icon-plus" }),
                                  _c("span", [_vm._v("点击上传图片")]),
                                ]
                              )
                            : _c(
                                "div",
                                [
                                  _c("AppMyImage", {
                                    staticStyle: {
                                      width: "200px",
                                      height: "150px",
                                    },
                                    attrs: {
                                      src: _vm.form.coverUrl,
                                      options: {
                                        width: 567,
                                        fixed: true,
                                        option: {
                                          fixed: true,
                                          fixedNumber: [4, 3],
                                          fixedBox: false,
                                        },
                                      },
                                    },
                                    on: {
                                      close: function ($event) {
                                        return _vm.delImage("coverUrl")
                                      },
                                      success: (res) =>
                                        _vm.changeImage("coverUrl", res),
                                    },
                                  }),
                                ],
                                1
                              ),
                          _c("div", { staticClass: "tips m-t-20" }, [
                            _c("div", [
                              _vm._v("横版缩略图是指在商品列表展示的图片。"),
                            ]),
                            _c("div", [
                              _vm._v(
                                "建议尺寸750*563或比例4:3，小于500K的JPG格式图片"
                              ),
                            ]),
                          ]),
                        ]),
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "封面图", prop: "contentUrl" } },
                      [
                        _c("div", { staticClass: "fl w-100p" }, [
                          _vm.form.contentUrl && _vm.form.contentUrl.length > 0
                            ? _c(
                                "div",
                                { staticClass: "fl m-r-10" },
                                _vm._l(
                                  _vm.form.contentUrl,
                                  function (item, index) {
                                    return _c(
                                      "div",
                                      { key: index, staticClass: "m-r-10" },
                                      [
                                        _c("AppMyImage", {
                                          staticStyle: {
                                            width: "160px",
                                            height: "120px",
                                          },
                                          attrs: {
                                            src: item,
                                            options: {
                                              width: 750,
                                              fixed: true,
                                              option: {
                                                fixed: true,
                                                fixedNumber: [4, 3],
                                                fixedBox: false,
                                              },
                                            },
                                          },
                                          on: {
                                            close: function ($event) {
                                              return _vm.delContentUrl(
                                                item,
                                                index
                                              )
                                            },
                                            success: (res) =>
                                              _vm.changeContentUrlImage(
                                                item,
                                                index,
                                                res
                                              ),
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                0
                              )
                            : _vm._e(),
                          _vm.form.contentUrl && _vm.form.contentUrl.length < 5
                            ? _c(
                                "div",
                                {
                                  staticClass: "image_poster",
                                  staticStyle: {
                                    width: "160px",
                                    height: "120px",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addContentUrl()
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "el-icon-plus" }),
                                  _c("span", [_vm._v("点击上传图片")]),
                                ]
                              )
                            : _vm._e(),
                        ]),
                        _c("div", { staticClass: "tips m-t-20" }, [
                          _c("div", [
                            _vm._v(
                              " 封面图是指在商品详情展示的图片。最多可上传五张，最少上传一张。 "
                            ),
                          ]),
                          _c("div", [
                            _vm._v("建议尺寸750*563，小于500K的JPG格式图片"),
                          ]),
                        ]),
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "学习说明" } },
                      _vm._l(_vm.learnExplain, function (item, index) {
                        return _c(
                          "el-row",
                          { key: index, staticClass: "m-b-10" },
                          [
                            _c("el-input", {
                              staticClass: "m-r-10",
                              staticStyle: { width: "500px" },
                              attrs: {
                                type: "textarea",
                                row: 5,
                                "show-word-limit": "",
                              },
                              model: {
                                value: _vm.learnExplain[index],
                                callback: function ($$v) {
                                  _vm.$set(_vm.learnExplain, index, $$v)
                                },
                                expression: "learnExplain[index]",
                              },
                            }),
                            _vm.learnExplain.length === index + 1
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "primary",
                                      icon: "el-icon-plus",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.addLearnExplain(item)
                                      },
                                    },
                                  },
                                  [_vm._v("添加")]
                                )
                              : _vm._e(),
                            _vm.learnExplain.length !== 1
                              ? _c(
                                  "el-button",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.learnExplain.splice(index, 1)
                                      },
                                    },
                                  },
                                  [_vm._v("删除")]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      }),
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "商品详情", prop: "content" } },
                      [
                        _c("AppUEditor", {
                          ref: "AppUEditor",
                          on: { change: _vm.change },
                          model: {
                            value: _vm.form.content,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "content", $$v)
                            },
                            expression: "form.content",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "店铺商品分类" } },
                      [
                        _c("el-cascader", {
                          attrs: {
                            options: _vm.goodsGroupingOption,
                            placeholder: "选择店铺商品分类",
                            props: {
                              multiple: true,
                              value: "catalogueId",
                              label: "catalogueName",
                              children: "catalogueVos",
                              expandTrigger: "hover",
                              checkStrictly: true,
                              emitPath: false,
                            },
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.groupingPicReqList,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "groupingPicReqList", $$v)
                            },
                            expression: "form.groupingPicReqList",
                          },
                        }),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.catalogueLoading,
                                expression: "catalogueLoading",
                              },
                            ],
                            staticClass: "EC1 m-l-20 pointer",
                            attrs: {
                              "element-loading-spinner": "el-icon-loading",
                            },
                            on: { click: _vm._getCatalogueList },
                          },
                          [_vm._v(" 刷新 ")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "平台商品分类",
                          prop: "catalogueReqList",
                        },
                      },
                      [
                        _c("el-cascader", {
                          attrs: {
                            options: _vm.platformGoodsGroupingOption,
                            placeholder: "选择平台商品分类",
                            props: {
                              multiple: true,
                              value: "catalogueId",
                              label: "catalogueName",
                              children: "catalogueVos",
                              expandTrigger: "hover",
                              checkStrictly: true,
                              emitPath: false,
                            },
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.catalogueReqList,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "catalogueReqList", $$v)
                            },
                            expression: "form.catalogueReqList",
                          },
                        }),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.catalogueLoading,
                                expression: "catalogueLoading",
                              },
                            ],
                            staticClass: "EC1 m-l-20 pointer",
                            attrs: {
                              "element-loading-spinner": "el-icon-loading",
                            },
                            on: { click: _vm._getPlatformCatalogueList },
                          },
                          [_vm._v(" 刷新 ")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "自定义锚点" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "328px" },
                          attrs: {
                            placeholder: "请输入自定义锚点",
                            maxlength: "12",
                            "show-word-limit": "",
                          },
                          model: {
                            value: _vm.form.anchorInfo,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "anchorInfo", $$v)
                            },
                            expression: "form.anchorInfo",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "header_tips" }, [_vm._v("添加规格")]),
                _c(
                  "div",
                  { staticClass: "m-t-20" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "添加规格", prop: "onlineList" } },
                      [
                        _c(
                          "el-table",
                          {
                            ref: "onlinelisttable",
                            staticStyle: { width: "955px" },
                            attrs: {
                              border: "",
                              "header-cell-style": {
                                background: "#f5f5f5",
                                padding: "0",
                              },
                              data: _vm.form.onlineList,
                              "max-height": "450",
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "sort",
                                label: "序号",
                                width: "55",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _c(
                                        "span",
                                        { staticClass: "table_sort" },
                                        [_vm._v(_vm._s(row.sort))]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "specName",
                                label: "名称",
                                width: "240",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "salePrice",
                                label: "价格",
                                width: "239",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(scope.row.salePrice.toFixed(2))
                                        ),
                                      ]),
                                      _vm._v("元 "),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "goodsNum",
                                label: "数量",
                                width: "150",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "peopleNum",
                                label: "人数",
                                width: "150",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: { label: "操作", width: "120" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "text",
                                            size: "small",
                                          },
                                          nativeOn: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              return _vm.editOnLineList(
                                                scope.row,
                                                scope.$index
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("修改")]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "text",
                                            size: "small",
                                          },
                                          nativeOn: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              return _vm.delSpecIds(
                                                scope.row,
                                                scope.$index
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" 删除 ")]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "m-t-20",
                            on: {
                              click: function ($event) {
                                return _vm.addOnlineList()
                              },
                            },
                          },
                          [_vm._v("添加规格")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "划线价格", prop: "marketPrice" } },
                      [
                        _c("el-input", {
                          staticClass: "w-120 m-r-10",
                          attrs: { type: "number", min: 0 },
                          model: {
                            value: _vm.form.marketPrice,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "marketPrice",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.marketPrice",
                          },
                        }),
                        _c("span", [_vm._v("元")]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "添加地址", prop: "city" } },
                  [
                    _vm.form.placeList
                      ? _c("chinaAreaList", {
                          model: {
                            value: _vm.form.placeList,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "placeList", $$v)
                            },
                            expression: "form.placeList",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _c("div", { staticClass: "header_tips m-t-50" }, [
                  _vm._v("服务与履约"),
                ]),
                _c(
                  "div",
                  { staticClass: "m-t-20" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "售后服务" } },
                      [
                        _c(
                          "el-select",
                          {
                            model: {
                              value: _vm.form.postSaleType,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "postSaleType", $$v)
                              },
                              expression: "form.postSaleType",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: {
                                label: "7天无理由退款（使用后不支持）",
                                value: 1,
                              },
                            }),
                            _c("el-option", {
                              attrs: { label: "不支持退款", value: 2 },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "m-t-20" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "服务保障" } },
                      [
                        _c("el-switch", {
                          attrs: { "active-value": 1, "inactive-value": 0 },
                          model: {
                            value: _vm.form.showServiceGuarantee,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "showServiceGuarantee", $$v)
                            },
                            expression: "form.showServiceGuarantee",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "header_tips m-t-50" }, [
                  _vm._v("上架设置"),
                ]),
                _c(
                  "div",
                  { staticClass: "m-t-20" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "上架设置" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.form.shelveFlag,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "shelveFlag", $$v)
                              },
                              expression: "form.shelveFlag",
                            },
                          },
                          [
                            _c(
                              "el-radio",
                              {
                                staticClass: "m-t-10",
                                staticStyle: { width: "100%" },
                                attrs: { label: 0 },
                              },
                              [_vm._v("立即上架")]
                            ),
                            _c(
                              "el-radio",
                              { staticClass: "m-t-10", attrs: { label: 2 } },
                              [
                                _c("span", [_vm._v("定时上架")]),
                                _c("el-date-picker", {
                                  staticClass: "m-l-20",
                                  attrs: {
                                    disabled: _vm.form.shelveFlag !== 2,
                                    type: "datetime",
                                    placeholder: "请设置时间",
                                    "picker-options": _vm.pickerOptions,
                                  },
                                  model: {
                                    value: _vm.form.shelveTime,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "shelveTime", $$v)
                                    },
                                    expression: "form.shelveTime",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-radio",
                              {
                                staticClass: "m-t-10",
                                staticStyle: { width: "100%" },
                                attrs: { label: 1 },
                              },
                              [_vm._v("暂不上架")]
                            ),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "EC1 m-t-20 m-b-10" }, [
                          _vm._v("更多设置"),
                        ]),
                        _c(
                          "div",
                          [
                            _c(
                              "el-checkbox",
                              {
                                attrs: { "true-label": 1, "false-label": 0 },
                                model: {
                                  value: _vm.form.shelveHideFlag,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "shelveHideFlag", $$v)
                                  },
                                  expression: "form.shelveHideFlag",
                                },
                              },
                              [_vm._v("隐藏")]
                            ),
                            _c("span", { staticClass: "tips m-l-20" }, [
                              _vm._v(
                                "上架的商品设置隐藏后，在店铺内不显示，但可以通过链接的方式访问"
                              ),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          [
                            _c(
                              "el-checkbox",
                              {
                                attrs: { "true-label": 1, "false-label": 0 },
                                model: {
                                  value: _vm.form.androidHideFlag,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "androidHideFlag", $$v)
                                  },
                                  expression: "form.androidHideFlag",
                                },
                              },
                              [_vm._v("在APP-安卓端隐藏")]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                attrs: { "true-label": 1, "false-label": 0 },
                                model: {
                                  value: _vm.form.iosHideFlag,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "iosHideFlag", $$v)
                                  },
                                  expression: "form.iosHideFlag",
                                },
                              },
                              [_vm._v("在APP-IOS端隐藏")]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                attrs: { "true-label": 1, "false-label": 0 },
                                model: {
                                  value: _vm.form.appletHideFlag,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "appletHideFlag", $$v)
                                  },
                                  expression: "form.appletHideFlag",
                                },
                              },
                              [_vm._v("在微信小程序端隐藏")]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                attrs: { "true-label": 1, "false-label": 0 },
                                model: {
                                  value: _vm.form.douAppletHideFlag,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "douAppletHideFlag", $$v)
                                  },
                                  expression: "form.douAppletHideFlag",
                                },
                              },
                              [_vm._v("在抖音小程序端隐藏")]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                attrs: { "true-label": 1, "false-label": 0 },
                                model: {
                                  value: _vm.form.htmlHideFlag,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "htmlHideFlag", $$v)
                                  },
                                  expression: "form.htmlHideFlag",
                                },
                              },
                              [_vm._v("在H5隐藏")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          [
                            _c(
                              "el-checkbox",
                              {
                                attrs: { "true-label": 1, "false-label": 0 },
                                model: {
                                  value: _vm.form.shelveHaltFlag,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "shelveHaltFlag", $$v)
                                  },
                                  expression: "form.shelveHaltFlag",
                                },
                              },
                              [_vm._v("停售")]
                            ),
                            _c("span", { staticClass: "tips m-l-20" }, [
                              _vm._v("上架的商品设置停售后，将停止售卖"),
                            ]),
                          ],
                          1
                        ),
                        _c("el-divider"),
                        _c("div", { staticClass: "tips" }, [
                          _c("i", { staticClass: "el-icon-warning" }),
                          _vm._v(
                            " 根据您上传的图文大小需要0-30分钟不等的转码时间，转码过程中该商品将隐藏不可显示，转码完成后会根据您的设置进行显示/隐藏。 "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "demo-drawer__footer" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  return _vm.$emit("close")
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_vm._v("提交")]
          ),
        ],
        1
      ),
      _c(
        "AppDialog",
        {
          attrs: { title: "添加规格", width: "500px", height: "260px" },
          model: {
            value: _vm.addOnlineListModal.visible,
            callback: function ($$v) {
              _vm.$set(_vm.addOnlineListModal, "visible", $$v)
            },
            expression: "addOnlineListModal.visible",
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "onlinelistForm",
              staticClass: "p-20",
              attrs: {
                model: _vm.addOnlineListModal.form,
                "label-width": "60px",
                rules: _vm.onlinelistRule,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "specName", label: "名称" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.addOnlineListModal.form.specName,
                      callback: function ($$v) {
                        _vm.$set(_vm.addOnlineListModal.form, "specName", $$v)
                      },
                      expression: "addOnlineListModal.form.specName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "salePrice", label: "价格" } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "400px" },
                    attrs: { precision: 2, min: 0 },
                    model: {
                      value: _vm.addOnlineListModal.form.salePrice,
                      callback: function ($$v) {
                        _vm.$set(_vm.addOnlineListModal.form, "salePrice", $$v)
                      },
                      expression: "addOnlineListModal.form.salePrice",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "goodsNum", label: "数量" } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "400px" },
                    attrs: { step: 1, "step-strictly": true, min: 0 },
                    model: {
                      value: _vm.addOnlineListModal.form.goodsNum,
                      callback: function ($$v) {
                        _vm.$set(_vm.addOnlineListModal.form, "goodsNum", $$v)
                      },
                      expression: "addOnlineListModal.form.goodsNum",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "peopleNum", label: "人数" } },
                [
                  _vm._v(
                    " " + _vm._s(_vm.addOnlineListModal.form.peopleNum) + " "
                  ),
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "sort", label: "序号" } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "400px" },
                    attrs: { step: 1, "step-strictly": true, min: 0 },
                    model: {
                      value: _vm.addOnlineListModal.form.sort,
                      callback: function ($$v) {
                        _vm.$set(_vm.addOnlineListModal.form, "sort", $$v)
                      },
                      expression: "addOnlineListModal.form.sort",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "ss-material-box-bottom",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.addOnlineListSure } }, [
                _vm._v("确定"),
              ]),
              _c("el-button", { on: { click: _vm.addOnlineListCancel } }, [
                _vm._v("取消"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }